import UserModel from './models/user'

const user = new UserModel

export default user
